import { useParams } from 'react-router';
import { LinkUnavailablePage } from './LinkUnavailablePage';
import { RedirectToServiceRequest } from './RedirectToServiceRequest';

export function OldDviRedirect() {
  const { shareToken } = useParams<{ shareToken: string }>();
  if (!shareToken) {
    return <LinkUnavailablePage />;
  }
  return <RedirectToServiceRequest kind="dvi" token={shareToken} />;
}
